import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';

export default function ProviderDetails({ providerId, onClose }) {
  const [provider, setProvider] = useState(null);

  useEffect(() => {
    const fetchProvider = async () => {
      const docSnap = await getDoc(doc(db, 'users', providerId));
      if (docSnap.exists()) {
        setProvider(docSnap.data());
      }
    };
    fetchProvider();
  }, [providerId]);

  if (!provider) return <div>Loading...</div>;

  const availableDates = (provider.availability || []).map(dateStr => new Date(dateStr));
  const tileClassName = ({ date, view }) => {
    if (view === 'month') {
      return availableDates.some(
        d => d.getFullYear() === date.getFullYear() &&
             d.getMonth() === date.getMonth() &&
             d.getDate() === date.getDate()
      ) ? 'available-date' : null;
    }
  };

  return (
    <div style={{ background: '#f9f9f9', padding: 20, margin: 20 }}>
      <h3>Provider Details</h3>
      <p><b>Name:</b> {provider.name}</p>
      <p><b>Category:</b> {provider.category}</p>
      <p><b>Contact:</b> {provider.contact}</p>
      <p><b>Address:</b> {provider.address}</p>
      <p><b>Approved:</b> {provider.approved ? 'Yes' : 'No'}</p>
      <div>
        <b>Availability Calendar:</b>
        <Calendar tileClassName={tileClassName} />
        <style>
          {`
            .available-date {
              background: #4caf50 !important;
              color: white !important;
              border-radius: 50%;
            }
          `}
        </style>
      </div>
      <button onClick={onClose} style={{ marginTop: 20 }}>Close</button>
    </div>
  );
}